import apiClient, { ApiResponse, PaginatedResponse } from '../api/client';

export interface PendingChange {
  id: number;
  entity_type: string;
  entity_id: number | null;
  action_type: 'create' | 'update' | 'delete' | 'deactivate' | 'activate';
  current_data: any;
  proposed_data: any;
  status: 'pending' | 'approved' | 'rejected';
  rejection_reason: string | null;
  created_by_id: number;
  approved_by_id: number | null;
  approved_at: string | null;
  created_at: string;
  updated_at: string;
  created_by?: any;
  approved_by?: any;
}

export interface ApprovalFilters {
  status?: 'pending' | 'approved' | 'rejected';
  entity_type?: string;
  action_type?: string;
  per_page?: number;
}

class ApprovalService {
  private baseUrl = '/admin/county/approvals';

  async getPendingChanges(filters?: ApprovalFilters): Promise<ApiResponse<PaginatedResponse<PendingChange>>> {
    const params = new URLSearchParams();
    if (filters?.entity_type) params.append('entity_type', filters.entity_type);
    if (filters?.action_type) params.append('action_type', filters.action_type);
    if (filters?.per_page) params.append('per_page', filters.per_page.toString());

    return apiClient.get<PaginatedResponse<PendingChange>>(
      `${this.baseUrl}/pending${params.toString() ? '?' + params.toString() : ''}`
    );
  }

  async getAllChanges(filters?: ApprovalFilters): Promise<ApiResponse<PaginatedResponse<PendingChange>>> {
    const params = new URLSearchParams();
    if (filters?.status) params.append('status', filters.status);
    if (filters?.entity_type) params.append('entity_type', filters.entity_type);
    if (filters?.action_type) params.append('action_type', filters.action_type);
    if (filters?.per_page) params.append('per_page', filters.per_page.toString());

    return apiClient.get<PaginatedResponse<PendingChange>>(
      `${this.baseUrl}/all${params.toString() ? '?' + params.toString() : ''}`
    );
  }

  async getPendingCount(): Promise<ApiResponse<{ count: number }>> {
    return apiClient.get<{ count: number }>(`${this.baseUrl}/count`);
  }

  async getChange(id: number): Promise<ApiResponse<PendingChange>> {
    return apiClient.get<PendingChange>(`${this.baseUrl}/${id}`);
  }

  async approve(id: number): Promise<ApiResponse<PendingChange>> {
    return apiClient.post<PendingChange>(`${this.baseUrl}/${id}/approve`);
  }

  async reject(id: number, reason?: string): Promise<ApiResponse<PendingChange>> {
    return apiClient.post<PendingChange>(`${this.baseUrl}/${id}/reject`, { reason });
  }
}

export const approvalService = new ApprovalService();
export default ApprovalService;
